import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 62F4C783-4BE1-4EB6-B454-E41A50B91857
 * name coffee-maker
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/coffee-maker.svg
 * tags
 * - Home Automation 
 * - Food / Drink 
 */
export const CoffeeMakerIcon = createSvgIcon(<><path d="M18 6V4H20V2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H20V20H15.97C17.2 19.09 18 17.64 18 16V11H8V16C8 17.64 8.81 19.09 10.03 20H6V4H8V6C8 6.55 8.45 7 9 7H17C17.55 7 18 6.55 18 6M13 8C13.55 8 14 8.45 14 9S13.55 10 13 10 12 9.55 12 9 12.45 8 13 8Z" /></>, 'CoffeeMakerIcon');
export default CoffeeMakerIcon